export default __webpack_public_path__ + "static/projectCover-bf81a5fff769c87804e62a59f29d8d81.png";